// @flow
export { default } from './TeamLogo';
